import { Checkbox, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateManagePrescriptionSubmissionData } from "../../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../../assets/AssetsStore";
import { BlackAdd, BlueAdd, ClockSmall } from "../../../assets/Logos/Icons";
import AddDataModal from "../../PrintPrescription/Components/Modals/AddDataModal/AddDataModal";
import { PrescriprionContext } from "../../PrintPrescription/PrintPrescription";
import Searchbox from "../SearchBox/Searchbox";
import styles from "./index.module.scss";
import Textarea from "react-expanding-textarea";

function InstructionBox({
  data,
  haveNote,
  name,
  addTitle,
  initialData,
  handleSearch,
  handleAdd,
  toggle,
  noteValue,
}) {
  const [isAddOpen, setAddOpen] = useState(false);
  const [searchValues, setSearchValues] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const {
    wholeData: { instructions },
    handleWholeData,
  } = useContext(PrescriprionContext);
  const { wholeData } = useContext(PrescriprionContext);
  const [textareaHeight, setTextareaHeight] = useState("auto");

  const { instruction_note } = useSelector(
    (state) => state?.managePrescription?.submissionData
  );

  useEffect(() => {
    const textarea = document.getElementById("noteTextarea");
    if (textarea) {
      setTextareaHeight(`${textarea.scrollHeight}px`);
    }
  }, [noteValue]);

  let dispatch = useDispatch();

  useEffect(() => {
    setSearchValues(createSearchOptionsWithData(initialData));
    //pushToWholeData("instructions", initialData);
  }, [initialData]);

  const handleAddInstruction = (e) => {
    handleAdd(e);
    handleSelectData(e, true);
  };

  const handleSearchBox = (value) => {
    handleSelectData(value);
    handleSearch(value);
    setSelectedData([...selectedData, { name: value }]);
    isSelected(value);
    const found = instructions.some((item) => item.name === value);
    console.debug(value, "is available ", found);
    if (!found) {
      pushToWholeData("instructions", [...instructions, { name: value }]);
    }
    setSearchValues(createSearchOptionsWithData(initialData));
  };

  const isInSearch = (e, data) => {
    for (let i = 0; i < e.length; i++) {
      if (e[i].toLowerCase() !== data?.name[i].toLowerCase()) {
        return false;
      }
    }
    return true;
  };

  const handleOnSearch = (e) => {
    if (initialData && initialData.length > 0 && e) {
      let filterData = initialData.filter((option) => isInSearch(e, option));
      setSearchValues(createSearchOptionsWithData(filterData));
    } else setSearchValues([]);
  };

  let handleNoteChange = (e) => {
    let { value } = e?.target;
    handleWholeData("instructionNote", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        instruction_note: value,
      })
    );
  };

  const handleSelectData = (data, value) => {
    console.debug("handleSelectData", value, data);
    const found = instructions.some((item) => item.name === data);
    console.debug(found);
    if (value && !found) {
      pushToWholeData("instructions", [...instructions, data]);
    } else if (!found) {
      let filteredData = instructions.filter(
        (item) => item?.name !== data?.name
      );
      pushToWholeData("instructions", filteredData);
    }
    // const isFound = selectedData.filter((item) => item === data).length
    //   ? true
    //   : false;
    // isFound
    //   ? setSelectedData(selectedData.filter((item) => item !== data))
    //   : setSelectedData([...selectedData, data]);
  };

  const pushToWholeData = (key, data) => {
    handleWholeData(key, data);
  };

  const isSelected = (param) => {
    let { name } = param;
    let data = wholeData?.instructions;

    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);

      return res && res.length > 0;
    }
  };

  const createSearchOptionsWithData = (data) => {
    if (data && data.length > 0) {
      let result = [];
      data.map((e) => result.push({ label: e?.name, value: e?.name }));
      return result;
    } else {
      return [];
    }
  };

  // useEffect(() => {
  //   if (selectedData.length > 0) {
  //     pushToWholeData("instructions", selectedData);
  //   }
  // }, [selectedData]);

  // const handleSubmissionData = (data) => {
  //   if (data) {
  //     setSelectedData(data);
  //   }
  // };

  // useEffect(() => {
  //   if (wholeData.instructions !== selectedData) {
  //     handleSubmissionData(wholeData.instructions);
  //   }
  // }, [wholeData.instructions]);

  console.debug("dddd", wholeData.instructionNote);

  const splitTextIntoChunks = (text, chunkSize) => {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    for (let i = 0; i < words.length; i++) {
      if ((currentChunk + words[i]).length <= chunkSize) {
        currentChunk += words[i] + " ";
      } else {
        chunks.push(currentChunk.trim());
        currentChunk = words[i] + " ";
      }
    }

    if (currentChunk.trim().length > 0) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  };

  const renderSplitText = (text) => {
    return splitTextIntoChunks(text, 50).map((chunk, index) => (
      <React.Fragment key={index}>
        {index !== 0 && <br />}
        {chunk}
      </React.Fragment>
    ));
  };

  return (
    <>
      <div className={styles.instruction_box_container}>
        <div className={styles.header}>
          <div className={styles.searchBox}>
            {/* <Select
                            suffixIcon={<img src={AssetStore.managePrescription.search} alt="" />}
                            onSelect={handleSearch ? handleSearch : () => { }}
                            getPopupContainer={trigger => trigger.parentNode}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={createSearchOptions()}
                        /> */}

            <Searchbox
              readOnly={wholeData?.isViewMode}
              value={instructions}
              options={createSearchOptionsWithData(initialData)}
              onSelect={handleSearchBox}
              onSearch={handleOnSearch}
              placeholder="Search"
            />
          </div>

          {!wholeData?.isViewMode && (
            <button
              className={styles.add_new_button}
              onClick={() => {
                setAddOpen(true);
              }}
            >
              <span>Add new</span>
              <BlackAdd />
            </button>
          )}
        </div>

        <div className={styles.body}>
          {/* <div className={styles.caption}>
            <ClockSmall/>
                        {name}
          </div> */}

          <div className={styles.data_list}>
            {/* Render selected options at top */}
            {data.map(
              (each, key) =>
                isSelected(each) && (
                  <div className={styles.data_list_item} key={key}>
                    <div>
                      <Checkbox
                        onChange={(e) => {
                          toggle && toggle(each);
                          handleSelectData(each, e?.target?.checked);
                        }}
                        checked={isSelected(each)}
                      />
                    </div>
                     <div>{renderSplitText(each?.name)}</div>
                  </div>
                )
            )}
            {/* Render unselected options */}
            {data.map(
              (each, key) =>
                !isSelected(each) && (
                  <div className={styles.data_list_item} key={key}>
                    <div>
                      <Checkbox
                        onChange={(e) => {
                          toggle && toggle(each);
                          handleSelectData(each, e?.target?.checked);
                        }}
                        checked={isSelected(each)}
                      />
                    </div>
                    <div>{renderSplitText(each?.name)}</div>
                  </div>
                )
            )}
          </div>
        </div>

        {haveNote ? (
          <div className={styles.footer}>
            <div className={styles.caption}>Note</div>
            <div className={styles.textareaContainer}>
              <Textarea
                value={wholeData.instructionNote || ""}
                onChange={handleNoteChange}
                onPaste={(e) => {
                  e.preventDefault(); // Prevent default paste behavior
                  const pastedData = e.clipboardData.getData("text/plain");
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  const currentValue = e.target.value;

                  // Calculate the available space
                  const availableSpace =
                    200 - (currentValue.length - (end - start));

                  // Truncate the pasted data if necessary
                  const truncatedPastedData = pastedData.substring(
                    0,
                    availableSpace
                  );

                  const newValue =
                    currentValue.substring(0, start) +
                    truncatedPastedData +
                    currentValue.substring(end);

                  // Use the existing handleNoteChange function to update the state
                  handleNoteChange({
                    target: {
                      value: newValue.substring(0, 200), // Ensure it doesn't exceed 200 characters
                    },
                  });

                  // Set cursor position after the pasted text
                  setTimeout(() => {
                    e.target.setSelectionRange(
                      start + truncatedPastedData.length,
                      start + truncatedPastedData.length
                    );
                  }, 0);
                }}
                id="noteTextarea"
                className={styles.textarea}
                style={{ height: textareaHeight }}
                maxLength={200}
              />
              {wholeData.instructionNote === "" && (
                <div className={styles.placeholder}>Enter note here</div>
              )}
            </div>
          </div>
        ) : null}
      </div>
      <AddDataModal
        onSubmit={(e) => {
          handleAdd && handleAddInstruction(e);
        }}
        title={addTitle ? addTitle : "Add new"}
        showModal={isAddOpen}
        hidemodal={() => {
          setAddOpen(false);
        }}
      />
    </>
  );
}

export default InstructionBox;
